import { createSlice } from '@reduxjs/toolkit';

const initialState = {

};

const dataWarehouseSlice = createSlice({
  name: 'dataWarehouseBlock',
  initialState: initialState,
  reducers: {
    reportDWH: (state, action) => { },
  }
});

export const {
  reportDWH
} = dataWarehouseSlice.actions;
export default dataWarehouseSlice.reducer;
